export default function lessRequireResolver(importPath) {
	let req = {};
	const path = `./${importPath}`;

	// require.context not support statement arguments
	if (process.env.CPA_ENV === 'everad') {
		req = require.context('../../cabinets/apps/everad', true, /^\.\/.*\.less$/);
	} else if (process.env.CPA_ENV === 'rocket') {
		req = require.context('../../cabinets/apps/rocket', true, /^\.\/.*\.less$/);
	}

	req(path);
}



// WEBPACK FOOTER //
// ./frontend/cabinets/config/less-require-resolver.js